import { Component, Input } from '@angular/core';

/**
 * Provenance whisper for AI parser fields (REDESIGN.md §0.5): one small muted
 * glyph after the field label telling whether the value was extracted by the
 * AI, suggested by the selected configuration, or edited manually. Renders
 * nothing when source is null. Raise the glyph to full opacity from the host
 * field via the `.ai-parser-field` class (hover/focus-within).
 */
@Component({
  selector: 'lib-pdf-ai-parser-source-glyph',
  standalone: false,
  templateUrl: './pdf-ai-parser-source-glyph.component.html',
  styleUrl: './pdf-ai-parser-source-glyph.component.scss'
})
export class PdfAiParserSourceGlyphComponent {
  @Input() source: 'ai' | 'config' | 'manual' | null = null;
  /** Name of the configuration that suggested the value; used by the 'config' tooltip. */
  @Input() configName = '';
}
